





if (typeof($) !== 'undefined') {
  $('.product-customizer-options').on('product-customizer-unbind-product-form-handlers', function() {
    // unbind backbone.js event
    $('.product-wrap').off('click', '.add-to-cart input');
  });
}